import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const token = Cookies.get('auth_token');

  return token ? <>{children}</> : <Navigate to="/" />;
};

export default PrivateRoute;
